import type { RouteObject } from 'react-router';
import { AdminPlatformAdminsPage } from '../pages/admin-platform-admins-page';

export const adminAdminsRoutes: RouteObject[] = [
  { path: 'admins', element: <AdminPlatformAdminsPage /> },
];
